export default class BoundingBox {
  xmin: number;
  xmax: number;
  ymin: number;
  ymax: number;

  constructor(xmin, xmax, ymin, ymax) {
    this.xmin = xmin;
    this.xmax = xmax;
    this.ymin = ymin;
    this.ymax = ymax;
  }

  contains(x, y) {
    return x >= this.xmin && x <= this.xmax && y >= this.ymin && y <= this.ymax;
  }

  getX() {
    return this.xmin;
  }

  getY() {
    return this.ymin;
  }

  getWidth() {
    return this.xmax - this.xmin;
  }

  getHeight() {
    return this.ymax - this.ymin;
  }

  //https://stackoverflow.com/a/2752387
  public rectanglesIntersect(
    minAx,
    minAy,
    maxAx,
    maxAy,
    minBx,
    minBy,
    maxBx,
    maxBy,
  ) {
    const aLeftOfB = maxAx < minBx;
    const aRightOfB = minAx > maxBx;
    const aAboveB = minAy > maxBy;
    const aBelowB = maxAy < minBy;

    return !(aLeftOfB || aRightOfB || aAboveB || aBelowB);
  }

  intersects(bb: BoundingBox) {
    return this.rectanglesIntersect(
      this.xmin,
      this.ymin,
      this.xmax,
      this.ymax,
      bb.xmin,
      bb.ymin,
      bb.xmax,
      bb.ymax,
    );
  }
}
